export const getAccountTypeOptions = (t, shouldShowAdminOption, allowedAccountTypes = null) => {
  return Object.keys(window.MARKET_CONSTANTS.USER_ACCOUNT_TYPES_DISPLAY_NAME).map(account_type =>
    (!shouldShowAdminOption && account_type === 'admin') ?
      null
      :
      // Add filtering for allowed account types
      (allowedAccountTypes && !allowedAccountTypes.includes(account_type)) ?
        null
        :
        <option key={account_type} value={account_type}>
          {t(`${window.MARKET_CONSTANTS.USER_ACCOUNT_TYPES_DISPLAY_NAME[account_type]}`)}
        </option>
  ).filter(o => !!o)
}